import React from "react";
import { connect } from "react-redux";
import { Typography } from "antd";
import { USER_INFO } from "../plannerConfig";

// Which CDC role implies access to which kind of site.
const ACCESS_MAP = {
  agency: ["ops"],
  payroll_admin: ["ops"],
  system_admin: ["planner", "ops"],
  team_manager: ["planner", "ops"],
  planner: ["planner"],
};

const DOMAIN_REMAP = { edinburghpark: "edinburghparks" };
const NAME_REMAP = { "Edinburgh Park": "Edinburgh Parks" };

export const getEnvironmentFromUrl = (url) => {
  if (url.indexOf("-dev.scopta.com") !== -1) return "dev";
  if (url.indexOf("-testing.scopta.com") !== -1) return "testing";
  if (url.indexOf("-staging.scopta.com") !== -1) return "staging";
  if (url.indexOf("localhost.workbenchtesting.com") !== -1) return "testing";
  return "production";
};

// Map Keycloak roles ("DC_WFP-<CDC name>-<CDC role>") to the sites the user
// can reach. Ported from the former standalone landing page.
export const generateLinks = (roles, env) => {
  const links = {};
  (Array.isArray(roles) ? roles : []).forEach((role) => {
    if (typeof role !== "string") return;
    const attrs = role.split("-");
    if (attrs.length !== 3) return;

    const cdcRole = attrs[2].toLowerCase();
    if (!(cdcRole in ACCESS_MAP)) return;

    const cdcName = NAME_REMAP[attrs[1].replace(/_/g, " ")] || attrs[1].replace(/_/g, " ");
    const cdcDomain =
      DOMAIN_REMAP[attrs[1].replace(/_/g, "").toLowerCase()] ||
      attrs[1].replace(/_/g, "").toLowerCase();
    const envSuffix = env === "production" ? "" : "-" + env;

    ACCESS_MAP[cdcRole].forEach((access) => {
      if (access === "ops") {
        // Ops sites share one base domain per environment.
        links[`${cdcDomain}-ops-${env}`] = {
          label: `${cdcName} (ops ${env} site)`,
          link: `https://coles-dcrp-ops${envSuffix}.scopta.com`,
        };
      } else {
        links[`${cdcDomain}-${access}-${env}`] = {
          label: `${cdcName} (${access} ${env} site)`,
          link: `https://coles-${cdcDomain}-${access}${envSuffix}.scopta.com`,
        };
      }
    });
  });
  return Object.values(links);
};

export const SiteChooser = ({ roles }) => {
  const links = generateLinks(roles, getEnvironmentFromUrl(window.location.href));

  return (
    <div style={{ padding: 32, maxWidth: 960, margin: "0 auto" }}>
      <Typography.Title level={3}>Choose a site</Typography.Title>
      {links.length === 0 ? (
        <Typography.Paragraph type="danger">
          You have not been granted access to any site.
        </Typography.Paragraph>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: links.length > 6 ? "1fr 1fr" : "1fr",
            gap: 12,
          }}
        >
          {links.map((l) => (
            <a key={l.link + l.label} href={l.link} className="button-link">
              {l.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  roles: (state[USER_INFO] && state[USER_INFO].data && state[USER_INFO].data.roles) || [],
});

export default connect(mapStateToProps)(SiteChooser);
